import httpClient from '../../services/httpClient';

export interface AuthError {
  message: string;
  status?: number;
}

const AUTH_KEY = 'isLoggedIn';

export const authService = {
  register: async (email: string, username: string, password: string): Promise<void> => {
    await httpClient.post('/api/Auth/register', { email, username, password });
    localStorage.setItem(AUTH_KEY, '1');
  },

  login: async (email: string, password: string): Promise<void> => {
    await httpClient.post('/api/Auth/login', { email, password });
    localStorage.setItem(AUTH_KEY, '1');
  },

  // Telegram mini-app auth: send the signed initData, server verifies it and sets
  // the same "cozek" session cookie as a normal login. One session, two entry points.
  loginWithTelegram: async (initData: string): Promise<void> => {
    await httpClient.post('/api/Auth/telegram', { initData });
    localStorage.setItem(AUTH_KEY, '1');
  },

  logout: async (): Promise<void> => {
    try {
      await httpClient.post('/api/Auth/logout');
    } finally {
      localStorage.removeItem(AUTH_KEY);
    }
  },

  isAuthenticated: (): boolean => {
    return localStorage.getItem(AUTH_KEY) === '1';
  },
};
